/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerstitle1Inputs */

const en_partnerstitle1 = /** @type {(inputs: Partnerstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partners`)
};

const de_partnerstitle1 = /** @type {(inputs: Partnerstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner`)
};

/**
* | output |
* | --- |
* | "Partners" |
*
* @param {Partnerstitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerstitle1 = /** @type {((inputs?: Partnerstitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerstitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerstitle1(inputs)
	return de_partnerstitle1(inputs)
});
export { partnerstitle1 as "partnersTitle" }